export default {
    url: 'products/powerocean',
    include: ['cn'],
};
